class SortedSource {
    _storage = new Map();
    constructor(settings) {
        if (settings) {
            this.add(settings);
        }
    }
    select(key, filter) {
        const settings = this._storage.get(key);
        if (!settings) {
            return;
        }
        if (!filter) {
            return settings[0];
        }
        return settings.find(filter);
    }
    selectAll(key, filter) {
        let settings;
        if (key) {
            settings = this._storage.get(key) || [];
        }
        else {
            settings = [...this._storage.values()].flat();
        }
        if (filter) {
            return settings.filter(filter);
        }
        return [...settings];
    }
    add(newSettings) {
        if (!newSettings.length) {
            return;
        }
        for (const newSetting of newSettings) {
            const settings = this._storage.get(newSetting.key);
            if (settings) {
                const index = settings.findIndex(setting => setting.priority <= newSetting.priority);
                if (index >= 0) {
                    settings.splice(index, 0, newSetting);
                }
                else {
                    settings.push(newSetting);
                }
            }
            else {
                this._storage.set(newSetting.key, [newSetting]);
            }
        }
    }
    removeByKeys(settingKeys) {
        for (const { key, priority } of settingKeys) {
            const settings = this._storage.get(key);
            if (!settings || !settings.length) {
                continue;
            }
            let removeCount = 0;
            let startIndex = -1;
            for (let i = 0; i < settings.length; i++) {
                const setting = settings[i];
                if (setting.priority > priority) {
                    continue;
                }
                if (setting.priority < priority) {
                    break;
                }
                if (startIndex === -1) {
                    startIndex = i;
                }
                removeCount++;
            }
            if (startIndex !== -1) {
                settings.splice(startIndex, removeCount);
            }
        }
    }
    replaceAll(settings) {
        const prevStorage = this._storage;
        try {
            this._storage = new Map();
            this.add(settings);
        }
        catch (error) {
            this._storage = prevStorage;
            throw error;
        }
    }
    // FIXME: Этот хак необходим, чтобы из воркера пробросить отсортированный Map
    get snapshot() {
        return this._storage;
    }
}

export { SortedSource };
//# sourceMappingURL=SortedSource.mjs.map
